export default "__VITE_ASSET__BHyHcKgQ__"